
import vFooter from '../common/footer.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import {search,list,modelfields} from '@/base/js/api'
export default {
name: 'app',
data() {
return {
tabIndex: 0,
searchInput:'',
up: false,
onFetching:false,
isView: false,
isfiltrate: false,
data:'',
classify:'',
classifyItem:'',
isUseClassify:false,
useClassify:'',
useClassifyItem:'',
useClassifySon:'',
useClassifySonItem:'',
fieldNames:[],
noMore:false,
totalPage:'',
tabNum:'',//分类选中
params:{
pageNo:1,
pageSize:10,
order:'',
categoryId:'',
productName:'',
p1:'',
p2:'',
p3:'',
p4:'',
p5:'',
p6:'',
p7:''
}
}
},
activated() {
console.log(this.scrollTop)
if (this.scrollTop) {
this.$refs.wrapper.scrollTop = this.scrollTop;
}
},
created(){

this._wxTool.setShare('','宇通客车-全民卖车')
let params= {}
if(this.$route.query.productName){
this.params.productName = this.$route.query.productName
this.searchInput = this.$route.query.productName
}
if(this.$route.query.categoryId){
this.params.categoryId = this.$route.query.categoryId.toString()

}
this.getData()
list(params).then(res=>{
if(res.code == 0){
console.log(res.data);
this.useClassify = res.data.productCategoryList
}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
modelfields(params).then(res=>{
if(res.code == 0){
console.log(res.data);
this.classify = res.data.list
}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
},
components: {
vFooter,
LoadMore,
Scroller
},
methods: {
carLength(e) {
let tabIndex = e
console.log(tabIndex)
this.tabIndex = tabIndex
if(this.up){
this.params.order = 'lengthDesc'
}else{
this.params.order = 'lengthAsc'

}
this.params.pageNo = 1
this.data = ''
this.onFetching = false
this.getData()
this.up = !this.up
this.isfiltrate = false
},
onScrollBottom(){

if(this.totalPage==1){
return
}
console.log(this.totalPage,this.params.pageNo)
if(this.totalPage<=this.params.pageNo){
this.$vux.toast.text('亲！已经到底了！', 'middle')
return
}
if (this.onFetching) {

} else {
this.onFetching = true
this.params.pageNo+=1
let params= this.params

search(params).then(res=>{
if(res.code == 0){
console.log(this.params.pageNo);
this.data = this.data.concat(res.data.product_list.list)
setTimeout(() => {
if(res.data.product_list.totalPage>this.params.pageNo){
this.onFetching = false
}
}, 2000)
if(!this.data[0]){
this.noMore = true
return
}
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
this.noMore = false
}else{
this.$vux.toast.text(res.msg, 'middle')
this.noMore = true
}
})
}
},
tabClassify(e){
if(e == 4){
let params= {
parentId:e
}
list(params).then(res=>{
if(res.code == 0){
console.log(res.data);
this.useClassifySon = res.data.productCategoryList
this.isUseClassify = !this.isUseClassify
}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
}else{
this.isUseClassify = false
}
this.useClassifyItem = e
this.params.categoryId = e
console.log(this.params.categoryId)
},
fangCheClassify(e){
this.useClassifySonItem = e
this.params.categoryId = e
},
tabItem(optionValue,fieldName){
let fieldNames = []
fieldNames[fieldName] = optionValue
this.fieldNames = Object.assign({}, this.fieldNames,fieldNames)
console.log(this.fieldNames[fieldName])
switch(fieldName){
case 'P1':
this.params.p1 = optionValue
break;
case 'P2':
this.params.p2 = optionValue
break;
case 'P3':
this.params.p3 = optionValue
break;
case 'P4':
this.params.p4 = optionValue
break;
case 'P5':
this.params.p5 = optionValue
break;
case 'P6':
this.params.p6 = optionValue
break;
case 'P7':
this.params.p7 = optionValue
break;
}
},
seat(e) {
let tabIndex = e
this.tabIndex = tabIndex
if(this.up){
this.params.order = 'seatDesc'
}else{
this.params.order = 'seatAsc'
}
this.params.pageNo = 1
this.data = ''
this.onFetching = false
this.getData()
this.up = !this.up
this.isfiltrate = false
},
reset(){
this.params.p1 = ''
this.params.p2 = ''
this.params.p3 = ''
this.params.p4 = ''
this.params.p5 = ''
this.params.p6 = ''
this.params.p7 = ''
this.params.categoryId = ''
this.params.productName=''
this.useClassifyItem = ''
this.useClassifySonItem = ''
this.fieldNames = []
this.isUseClassify = false
this.params.pageNo= 1
this.data = ''
this.onFetching = false
this.isfiltrate = !this.isfiltrate;
this.getData()
},
filtrate(e) {
this.tabIndex = 0,
this.isfiltrate = !this.isfiltrate
this.params.order = ''
},
view(e) {
this.isView = !this.isView
if(this.isView){
this.data = ''
this.params.pageNo = 1
this.onFetching = false
this.getData()
}

},
okBtn(){
this.params.pageNo = 1
this.data = '';
this.onFetching = false
this.getData();
this.isfiltrate = !this.isfiltrate
},
getData(){
let params= this.params
search(params).then(res=>{
if(res.code == 0){
this.data = res.data.product_list.list;
console.log(this.data)
console.log(res.data.product_list.totalPage)
this.totalPage = res.data.product_list.totalPage
if(!this.data[0]){
this.noMore = true
return
}
this.noMore = false
this.$nextTick(() =>{
this.$refs.scrollerBottom.reset({top: 0})
})
}else{
this.$vux.toast.text(res.msg, 'middle')
this.noMore = true
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/product/product.vue